import { render, staticRenderFns } from "./ProductsResultsTable.vue?vue&type=template&id=7e61d87b&scoped=true"
import script from "./ProductsResultsTable.vue?vue&type=script&lang=js"
export * from "./ProductsResultsTable.vue?vue&type=script&lang=js"
import style0 from "./ProductsResultsTable.vue?vue&type=style&index=0&id=7e61d87b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e61d87b",
  null
  
)

export default component.exports